import type { StateCreator } from "zustand";

import { createStore } from "./createStore";

export interface ScratchpadChipState {
  /** Mirrors the scratchpad's own pending-work flag: strokes, text, photos. */
  hasWork: boolean;
  /** Optimistic: a stroke has begun but has not been counted as work yet. */
  strokeStarted: boolean;
  thumbnail: string | null;

  setHasWork: (value: boolean) => void;
  markStrokeStarted: () => void;
  clearStrokeStarted: () => void;
  setThumbnail: (value: string) => void;
}

const base: StateCreator<ScratchpadChipState> = (set, get) => ({
  hasWork: false,
  strokeStarted: false,
  thumbnail: null,

  setHasWork: (value) =>
    set(
      value
        ? { hasWork: true }
        : { hasWork: false, strokeStarted: false, thumbnail: null },
    ),

  // The chip appears the moment a stroke begins, before there is anything to
  // show: waiting for the export would leave the student drawing into a bar
  // that has not reacted yet.
  markStrokeStarted: () => {
    if (!get().strokeStarted) set({ strokeStarted: true });
  },

  // Only the optimism: counted work still holds the chip up on its own.
  clearStrokeStarted: () => {
    if (get().strokeStarted) set({ strokeStarted: false });
  },

  setThumbnail: (value) => set({ thumbnail: value }),
});

export const useScratchpadChipStore = createStore<ScratchpadChipState>(
  "ScratchpadChipStore",
  base,
);

export const selectChipVisible = (state: ScratchpadChipState): boolean =>
  state.hasWork || state.strokeStarted;
